import {createAction} from "@reduxjs/toolkit";
import {MeterFlowVolumeSearchCriteria} from "@ots-frontend/ots-data";

export const setUIMeterFlowVolumeSearchFilter = createAction<MeterFlowVolumeSearchCriteria>("ots-ui/meter-flow-volume/setSearchFilter");
